<template>
    <!-- Works Section -->
    <section class="works-section">
        <div class="container">
            <div class="services-header aos" data-aos="fade-up">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section-content">
                            <h2>How It Works</h2>
                            <div class="our-img-all-1">
                                <img src="@/assets/img/icons/cuttor-small.svg" alt="Scissor">
                            </div>
                            <p>Our Barbershop & Tattoo Salon provides classic services combined with innovative
                                techniques.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row g-4">
                <div class="col-md-4 col-sm-6 col-12">
                    <div class="works-main aos" data-aos="fade-right">
                        <div class="works-tops">
                            <div class="works-top-img">
                                <img src="@/assets/img/services/service-98.jpg" alt="image">
                                <span>1</span>
                            </div>
                        </div>
                        <div class="works-bottom">
                            <a href="javascript:void(0);">
                                <h4 class="mb-2">Discover</h4>
                            </a>
                            <p>Customers can browse or search for specific products or services using categories,
                                filters, or search bars.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 col-12">
                    <div class="works-main aos" data-aos="fade-up">
                        <div class="works-tops">
                            <div class="works-top-img works-load-profile">
                                <img src="@/assets/img/services/service-99.jpg" alt="image">
                                <span>2</span>
                            </div>
                        </div>
                        <div class="works-bottom">
                            <a href="javascript:void(0);">
                                <h4 class="mb-2">Book</h4>
                            </a>
                            <p>Customers can add items to their shopping cart. For services, they may select a
                                service and proceed to book.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 col-12">
                    <div class="works-main aos" data-aos="fade-left">
                        <div class="works-tops">
                            <div class="works-top-img">
                                <img src="@/assets/img/services/service-100.jpg" alt="image">
                                <span>3</span>
                            </div>
                        </div>
                        <div class="works-bottom">
                            <a href="javascript:void(0);">
                                <h4 class="mb-2">Enjoy</h4>
                            </a>
                            <p>The Customer fulfills the order by either providing the service to the Customers &
                                Get leads from the local Persons in our Platform.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- /Works Section -->

    <!-- client section -->
    <section class="client-sections review-four">
        <div class="client-bg">
            <img src="@/assets/img/bg/client-bg1.svg" class="img-fluid h-100 w-100" alt="bg">
        </div>
        <div class="container">
            <div class="services-header aos" data-aos="fade-up">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section-content section-client">
                            <h2>What Our Client Says</h2>
                            <div class="our-img-all-1">
                                <img src="@/assets/img/icons/cuttor-sm-white.svg" alt="image">
                            </div>
                            <p>Description highlights the value of client feedback, showcases real testimonials, and
                                encourages potential clients.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class=" slider say-about slider-for aos" data-aos="fade-up">
                <Carousel>
                    <Slide v-for="item in indexthreework" :key="item.id">
                    <div class="review-love-group">
                        <div class="quote-love-img text-start">
                            <img class="img-fluid" src="@/assets/img/icons/quote.svg" alt="image">
                        </div>
                        <p class="review-passage">{{ item.hint }}</p>
                        <div class="say-name-blk text-center">
                            <h5>{{item.Name}}</h5>
                            <p>{{item.Country}}</p>
                        </div>
                    </div>
                    </Slide>
                </Carousel>
            
            </div>            
            <div class="slider client-img slider-nav client-pro aos" data-aos="fade-up">
                <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints"  >
                <Slide v-for="item in indexthreework" :key="item.id" class="testimonial-thumb">
                    <img :src="require(`@/assets/img/profiles/${item.img}`)" alt="">
                </Slide>
            </Carousel>
            </div>        
        </div>
    </section>
    <!-- /client section -->
</template>
<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexthreework from '@/assets/json/indexthreework.json'
import "vue3-carousel/dist/carousel.css";
export default {
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    data() {
        return {
            indexthreework: indexthreework, 
            settings: {
                itemsToShow: 1,
                snapAlign: "center",
                loop: true,
                margin: 24,
            },

            breakpoints: {
                575: {
                    itemsToShow: 2,
                    snapAlign: "center"
                },
                // 700px and up
                767: {
                    itemsToShow: 2,
                    snapAlign: "center"
                },
                // 991px and up
                991: {
                    itemsToShow: 2,
                    snapAlign: "center"
                },
                // 1024 and up
                1024: {
                    itemsToShow: 3,
                    snapAlign: "start"
                }
            },
            settingswork: {
                itemsToShow: 1,
                snapAlign: "center",
                loop: true,
                margin: 24,
                asNavFor: '.client-img.slider-nav'
            },
        }
    },
}
</script>
